module.exports = __webpack_public_path__ + "img/project-edit-budget-graph.5ced49e0.png";